import mx from '../mx';

export const mxAbstractCanvas2D = mx.mxAbstractCanvas2D;
